"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var Avatar_1 = __importDefault(require("components/Avatars/Avatar"));
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var LoadingSpinner_1 = __importDefault(require("components/LoadingSpinner"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var CompanyActions_1 = __importDefault(require("../CompanyActions"));
var ImpersonateTable_1 = __importDefault(require("../ImpersonateTable"));
var CompanyDetails_1 = __importDefault(require("./CompanyDetails"));
var Header_1 = __importDefault(require("./Header"));
var Section_1 = __importDefault(require("./Section"));
var CustomerPreview = function (_a) {
    var company = _a.company, onClickClose = _a.onClickClose;
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'companies', doc: company.id, storeAs: "companyById".concat(company.id) },
        { collection: 'recharger_companies', doc: company.id, storeAs: "rechargerCompanyById".concat(company.id) },
    ]; });
    var selectAccFirm = react_1.default.useMemo(function () { return (0, single_1.makeSelectCompanyFromCompaniesForAdmins)(company.accountingFirmId); }, [company.accountingFirmId]);
    var selectFullCompany = react_1.default.useMemo(function () { return (0, single_1.makeSelectFullCompany)(company.id); }, []);
    var selectRechargerCompany = react_1.default.useMemo(function () { return (0, single_1.makeSelectRechargerCompany)(company.id); }, []);
    var accountingFirm = (0, react_redux_1.useSelector)(selectAccFirm);
    var fullCompany = (0, react_redux_1.useSelector)(selectFullCompany);
    var rechargerCompany = (0, react_redux_1.useSelector)(selectRechargerCompany);
    var _b = __read((0, hooks_1.useSubmitter)('recharger_companies', company.id, { isAdvancedFlow: !(rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.isAdvancedFlow) }), 2), rechCompanySubmitter = _b[0], isSendingRechCompany = _b[1];
    return ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: "100%", height: "100%", minHeight: "88vh", mb: 4 }, { children: (0, jsx_runtime_1.jsxs)(ScrollDiv_1.default, __assign({ backgroundColor: "white", width: "auto", viewStyle: { paddingBottom: 2 } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 980, mt: 3, mr: 2, display: "flex", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(IconButtons_1.CloseButton, { onClick: onClickClose }) })), rechargerCompany && ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ mr: 8 }, { children: ["New account", (0, jsx_runtime_1.jsx)(Switch_1.default, { checked: rechargerCompany.isAdvancedFlow, onChange: function () { return rechCompanySubmitter(); }, disabled: isSendingRechCompany }), "Ready for beta features"] }))), (0, jsx_runtime_1.jsx)(Header_1.default, { item: company }), accountingFirm && ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ my: 4, width: "100%", display: "flex" }, { children: ["Accounting Firm: ", (0, jsx_runtime_1.jsx)(Avatar_1.default, { sx: { width: 30, height: 30, mx: 0.5 }, profile: accountingFirm }), accountingFirm.name] }))), (0, jsx_runtime_1.jsx)(CompanyDetails_1.default, { item: company }), fullCompany ? (0, jsx_runtime_1.jsx)(CompanyActions_1.default, { company: fullCompany }) : (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {}), (0, jsx_runtime_1.jsx)(Section_1.default, { title: "Impersonate a user", component: ImpersonateTable_1.default, company: company })] })) })));
};
exports.default = CustomerPreview;
